<template>
  <b-card>
    <!-- Password Confirm Modal -->
    <b-modal v-model="showConfirm" title="Confirm Changes" centered hide-footer>
      <p class="text-black">Enter your password to save changes.</p>
      <b-form-input
        v-model="confirmPassword"
        type="password"
        placeholder="Enter password"
        class="mb-2"
        @keyup.enter="handleSave"
      />
      <div class="d-flex justify-content-end">
        <b-button variant="outline-secondary" class="mr-1" @click="showConfirm = false">Cancel</b-button>
        <b-button variant="success" :disabled="!confirmPassword" @click="handleSave">Confirm & Save</b-button>
      </div>
    </b-modal>

    <div class="d-flex justify-content-between align-items-center">
      <h5>API Configuration</h5>
      <b-button variant="success" @click="showConfirm = true">
        <feather-icon icon="SaveIcon" />
        Save Changes</b-button
      >
    </div>
    <b-form>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group>
            <label class="font-weight-bold" for="rate-limit">Rate Limit</label>
            <b-form-input
              id="rate-limit"
              v-model="form.rateLimit"
              type="number"
            />
          </b-form-group>
          <b-form-group>
            <label class="font-weight-bold" for="request-timeout"
              >Request Timeout</label
            >
            <b-form-input
              id="request-timeout"
              v-model="form.requestTimeout"
              type="number"
            />
          </b-form-group>

          <b-form-group>
            <label class="font-weight-bold" for="max-file-size"
              >Max File Size (MB)</label
            >
            <b-form-input
              id="max-file-size"
              v-model="form.maxFileSize"
              type="number"
            />
          </b-form-group>
          <b-form-group>
            <label class="font-weight-bold" for="api-version"
              >API Version</label
            >
            <v-select
              :value="form.apiVersion"
              :options="apiVersions"
              :clearable="false"
              :reduce="(val) => val"
              @input="(val) => (form.apiVersion = val)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group>
            <label class="font-weight-bold" for="allowed-origins"
              >Allowed Origins</label
            >
            <b-form-textarea
              id="allowed-origins"
              v-model="form.allowedOrigins"
              placeholder="Enter one origin per line"
              rows="3"
            />
          </b-form-group>

          <b-form-group>
            <label class="font-weight-bold" for="webhook-secret"
              >Webhook Secret</label
            >
            <div class="d-flex align-items-center" style="gap: 8px">
              <b-form-input
                id="webhook-secret"
                v-model="form.webhookSecret"
                type="password"
                readonly
              />
              <b-button variant="outline-secondary">
                <feather-icon icon="RefreshCwIcon" />
              </b-button>
            </div>
          </b-form-group>

          <b-form-group>
            <label class="font-weight-bold" for="cache-timeout"
              >Cache Timeout (seconds)</label
            >
            <b-form-input
              id="cache-timeout"
              v-model="form.cacheTimeout"
              type="number"
            />
          </b-form-group>
          <b-form-group>
            <label class="font-weight-bolder"> Enable API Caching </label>
            <div class="d-flex align-items-center justify-content-between">
              <span> Cache API responses for better performance </span>
              <b-form-checkbox v-model="form.enableCaching" switch />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BFormCheckbox,
  BFormTextarea,
  BInputGroup,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BFormCheckbox,
    BFormTextarea,
    BInputGroup,
    BModal,
    vSelect,
  },
  data() {
    const apiVersions = [
      { key: "1.0", label: "Version 1.0" },
      { key: "2.0", label: "Version 2.0 (Current)" },
    ];
    return {
      form: {
        rateLimit: 1000,
        allowedOrigins: `https://app.upc.com.au
https://admin.upc.com.au`,
        requestTimeout: 30,
        maxFileSize: 10,
        apiVersion: "2.0",
        webhookSecret: "********",
        cacheTimeout: 299,
        enableCaching: true,
      },
      apiVersions,
      showConfirm: false,
      confirmPassword: "",
    };
  },
  methods: {
    handleSave() {
      if (!this.confirmPassword) return;
      this.showConfirm = false;
      this.confirmPassword = "";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
